import toastr from "toastr";
import EmbedController from "../../embed/EmbedController";
import { applyCustomLogoUpload, createUniqueShopifyProduct } from "./createUniqueShopifyProduct";
import { getConfigurationBlocker } from "./getConfigurationBlocker";
import { getFinalPrice } from "./getFinalPrice";
import { getShoppingCartData } from "./getShoppingCartData";

export function isDefaultShopifyProductData(shopifyData) {
  return !shopifyData?.brand && !shopifyData?.model && !shopifyData?.year;
}

function showWishlistPendingToast() {
  return toastr.info("Adding to wishlist. Please wait", "", {
    timeOut: 0,
    extendedTimeOut: 0,
    tapToDismiss: false,
    closeButton: false,
    iconClass: "toast-info toast-pending",
  });
}

function takeOverToast(toastElement, type, message) {
  if (toastElement?.length) {
    toastElement.removeClass("toast-info toast-success toast-error toast-warning toast-pending").addClass(`toast-${type}`);
    toastElement.find(".toast-message").text(message);
    window.setTimeout(() => {
      toastr.clear(toastElement, { force: true });
    }, 5000);
    return;
  }
  if (type && message) {
    toastr[type](message);
  }
}

export async function addConfiguredProductToWishlist({ productsState, componentsState, itemsState, waitForProductScreenshot, setItemsActiveIds, sessionId }) {
  if (!EmbedController.isEmbedded) {
    toastr.error("Wishlist is only available when embedded in Shopify.");
    return false;
  }

  const blocker = getConfigurationBlocker(itemsState);
  if (blocker) {
    toastr.error(blocker);
    return false;
  }

  const pendingToast = showWishlistPendingToast();

  try {
    const shopifyData = productsState?.activeObj?.shopify;
    // if (isDefaultShopifyProductData(shopifyData)) {
    //   AlertSlackOfError(
    //     "Wishlist Bug - Default Product Data Detected",
    //     `Default product data being used in wishlist: ${JSON.stringify({
    //       brand: shopifyData?.brand,
    //       model: shopifyData?.model,
    //       year: shopifyData?.year,
    //       displayName: shopifyData?.displayName,
    //       handle: shopifyData?.handle,
    //       url: window.location.href,
    //     })}`,
    //   );
    //   alert("Something went wrong when adding to the wishlist. Please refresh the page and try again - your configuration is saved.");
    //   return false;
    // }

    const customImageBase64 = await waitForProductScreenshot();
    const [cartSubmissionObj] = getShoppingCartData(productsState, componentsState, itemsState, 1, "", "");

    await applyCustomLogoUpload(cartSubmissionObj, sessionId, { itemsState, setItemsActiveIds });

    cartSubmissionObj.items[0].properties._customUrl = EmbedController.parentUrl || window.location.href;

    const created = await createUniqueShopifyProduct({
      productObj: shopifyData,
      cartSubmissionObj,
      finalPrice: getFinalPrice(productsState, componentsState, itemsState, true),
      customImageBase64,
      sessionId,
    });

    console.log("[wishlist] sending", {
      productId: created.productId,
      variantId: created.variantId,
      url: created.url,
    });

    await EmbedController.sendAddToWishlist({
      productId: created.productId,
      variantId: created.variantId,
      url: created.url,
      properties: {
        ...cartSubmissionObj.items[0].properties,
        _customUrl: created.url,
      },
    });

    takeOverToast(pendingToast, "success", "Added to wishlist");
    return true;
  } catch (error) {
    takeOverToast(pendingToast, "error", "Error adding to wishlist. Please try again.");
    throw error;
  }
}
